import { Navigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";

// Utility to decode token and get user info
const getUserFromToken = (token) => {

    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded.role === "manager" ? decoded.user_table_id : decoded.user_id;
    } catch (error) {
        return null;
    }
};

// Route protection wrapper
const ProtectedRouteWithUserCheck = ({ children }) => {
    const { user_id } = useParams();
    const { jwtToken } = useContext(AuthContext);
    const actualUserId = getUserFromToken(jwtToken);

    if (!actualUserId) {
        console.log("User not authenticated or token invalid");
        return <Navigate to="/unauthorized" replace />;
    }

    if (parseInt(user_id) !== actualUserId) {
        console.log("User ID mismatch: Access denied");
        console.log(`Expected: ${user_id}, Actual: ${actualUserId}`);
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRouteWithUserCheck;
